import { defineStore } from 'pinia'
import { CampanhasService, CreateCampanha, UpdateCampanha, ResponseCampanha, CreateCampanhaMensagem, ResponseCampanhaMensagem, ImportarContatosCampanhaDto, ResponseCampanhaImportacao } from '@/services/campanhas/campanhas.service'
import { IdCampanha } from '@/services/common-types'

export const useCampanhasStore = defineStore('campanhas', {
    state: () => ({
        initialized: false,
        service: new CampanhasService(),
        campanhas: [] as ResponseCampanha[],
    }),
    actions: {
        async init() {
            if (this.initialized) return
            this.initialized = true
            this.campanhas = await this.service.getAll()
        },
        async get() {
            await this.init()
            this.campanhas = await this.service.getAll()
            return this.campanhas
        },
        async criarCampanha(dto: CreateCampanha) {
            await this.init()
            const result = await this.service.create(dto)
            await this.get()
            return result
        },
        async atualizarCampanha(dto: UpdateCampanha) {
            await this.init()
            const result = await this.service.update(dto)
            await this.get()
            return result
        },
        async deletarCampanha(id: IdCampanha) {
            await this.init()
            const result = await this.service.delete(id)
            await this.get()
            return result
        },
        async getMensagens(idCampanha: IdCampanha): Promise<ResponseCampanhaMensagem[]> {
            return await this.service.getMensagens(idCampanha)
        },
        async adicionarMensagem(idCampanha: IdCampanha, dto: CreateCampanhaMensagem) {
            return await this.service.createMensagem(idCampanha, dto)
        },
        async importarContatos(idCampanha: IdCampanha, dto: ImportarContatosCampanhaDto) {
            return await this.service.importarContatos(idCampanha, dto)
        },
        async getImportacoes(idCampanha: IdCampanha): Promise<ResponseCampanhaImportacao[]> {
            return await this.service.getImportacoes(idCampanha)
        },
        atualizarCampanhaLocal(dados: { id: string; totalMensagens: number; mensagensEnviadas: number; mensagensFalha: number }) {
            const idx = this.campanhas.findIndex(d => d.id === dados.id)
            if (idx !== -1) {
                this.campanhas[idx] = { ...this.campanhas[idx], ...dados }
            }
        },
    },
})
